export default __webpack_public_path__ + "static/media/leaflate-icon.1eb77dde.svg";